import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import BookingPortal from './components/BookingPortal';
import Dashboard from './components/Dashboard';
import './cal.css';

// Global keyframe for loading spinner
const style = document.createElement('style');
style.textContent = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  * { box-sizing: border-box; }
  body { margin: 0; padding: 0; }
  input:focus, button:focus {
    outline: 2px solid #B8860B;
    outline-offset: 2px;
  }
`;
document.head.appendChild(style);

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public booking portal */}
        <Route path="/book/:slug" element={<BookingPortal />} />

        {/* Owner dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Default: redirect to dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
